import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { headerTitles } from "../../../actions/masterdata/masterdata";
import { hasAccess } from "../../../utils";
import ModulesSubMenu from "./ModulesSubMenu";
import {
  Advances,
  Bills,
  CostCenter,
  CreditNote,
  Estimate,
  Expenses,
  Invoices,
  Items,
  Merchants,
  PaymentReceived,
  PaymentsMade,
  Projects,
  PurchaseOrders,
  Reports,
  SalesOrder,
  TDS,
  Taxes,
  Trips,
} from "../../../assets/icons/Modules";

const CustomModules = ({ hasWriteAccess }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const cols = [
    {
      title: t("Update Correspondence Address"),
      description: t(
        "Request to change your registered correspondence address for receiving bank statements and notifications."
      ),
      to: "",
      hasAccess: true || hasAccess("update_address", "read"),
      moduleIcon: "🏠", // Home or Address Icon
    },
    {
      title: t("NACH Cancellation Request"),
      description: t(
        "Request to cancel your National Automated Clearing House (NACH) mandate to stop automated debits from your account."
      ),
      to: "",
      hasAccess: true || hasAccess("nach_cancellation", "read"),
      moduleIcon: "🔁", // Cycle or Cancel Icon
    },
    {
      title: t("Passbook Activation/Deactivation"),
      description: t(
        "Request to activate or deactivate your passbook for maintaining a record of your account transactions."
      ),
      to: "",
      hasAccess: true || hasAccess("passbook_settings", "read"),
      moduleIcon: "📒", // Passbook Icon
    },
    {
      title: t("Request for Interest Certificate"),
      description: t(
        "Request for an official document certifying the interest earned on your account for tax purposes."
      ),
      to: "",
      hasAccess: true || hasAccess("interest_certificate", "read"),
      moduleIcon: "📄", // Document Icon
    },
    {
      title: t("Request for Balance Certificate"),
      description: t(
        "Request for a formal statement indicating your current account balance, often needed for loan applications or verification."
      ),
      to: "",
      hasAccess: true || hasAccess("balance_certificate", "read"),
      moduleIcon: "💰", // Money Icon
    },
    {
      title: t("Chequebook Request"),
      description: t(
        "Request for the issuance of a new chequebook to facilitate your payment transactions."
      ),
      to: "",
      hasAccess: true || hasAccess("chequebook_request", "read"),
      moduleIcon: "💳", // Cheque/Payment Icon
    },
    {
      title: t("Stop Cheque Instruction"),
      description: t(
        "Request to halt the processing of a specific cheque that has been issued but not yet cleared."
      ),
      to: "",
      hasAccess: true || hasAccess("stop_cheque", "read"),
      moduleIcon: "🚫", // Stop Icon
    },
    {
      title: t("Issued Cheque Status Inquiry"),
      description: t(
        "Inquiry regarding the status of a cheque you have issued, including whether it has been cleared or is still pending."
      ),
      to: "",
      hasAccess: true || hasAccess("cheque_status_inquiry", "read"),
      moduleIcon: "📋", // Status or Document Icon
    },
    {
      title: t("Fraud Report / Dispute Submission"),
      description: t(
        "Report any fraudulent activity on your account or raise a dispute regarding unauthorized transactions."
      ),
      to: "",
      hasAccess: true || hasAccess("fraud_report", "read"),
      moduleIcon: "⚠️", // Warning or Alert Icon
    },
    {
      title: t("Change of Home Branch Request"),
      description: t(
        "Request to change your designated home branch for account management and services."
      ),
      to: "",
      hasAccess: true || hasAccess("home_branch_change", "read"),
      moduleIcon: "🏦", // Bank Icon
    },
  ];

  dispatch(
    headerTitles({
      title: "Service Requests",
      description: "",
    })
  );
  return (
    <>
      <div className="custom_module">
        <div className="container_module">
          <div className="module_header">
            <div className="left_header">{t("module_name")}</div>
            <div className="right_header">{t("desc")}</div>
          </div>
          <div className="module_content">
            <ModulesSubMenu
              submenuheader={t("Service Requests")}
              submenuColumn={cols}
              hasAccess={true}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomModules;
